import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "statistic" }
const _hoisted_2 = { class: "statistic-row" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "statistic-row" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "statistic-row" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "statistic-row" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "statistic-row" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "statistic-row" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "statistic-row" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "value" }

import Timer from "@/components/_partials/Timer.vue";
  import moment from "moment-timezone";
  import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
  import { trans } from "@/utils/trans";
  import { format_currency } from "@/utils/currencies";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { ILot } from "@/models";
  import { LotStatuses, LotSoldStatuses, AuctionStatuses } from "@/enum";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Statistic',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const auction = computed(() => auctionStore.auction);
  const auctionStatus = computed(() => auctionStore.auction.status);
  const biddersCount = computed(() => auction.value.bidders_count);
  const lots = computed(() => auctionStore.lots);
  const passedLots = computed(() => lots.value.filter(
      (item) => item.status === LotStatuses.LIVE || item.status === LotStatuses.ENDED)
  );
  const soldLots = computed(() => {
    return auctionStore.lots?.filter((lot: ILot) => lot.sold_status === LotSoldStatuses.SOLD);
  });
  const unsoldLots = computed(() => {
    return auctionStore.lots?.filter((lot: ILot) => lot.sold_status === LotSoldStatuses.UNSOLD);
  });
  const totalSales = computed(() => soldLots.value.reduce((sum, lot) => sum + lot.current_bid, 0));
  const highestPrice = computed(() => soldLots.value.reduce((max, lot) => Math.max(max, lot.current_bid), 0));

  const currentDuration = ref(0);
  let durationInterval: number | null = null;

  const timerDays = computed(() => Math.floor(currentDuration.value / (24 * 60 * 60)));
  const timerHours = computed(() => Math.floor((currentDuration.value % (24 * 60 * 60)) / (60 * 60)));
  const timerMinutes = computed(() => Math.floor((currentDuration.value % (60 * 60)) / 60));
  const timerSeconds = computed(() => currentDuration.value % 60);
  const timerIsPaused = computed(() => auctionStatus.value === AuctionStatuses.ENDED);

  const timePerLot = computed(() => passedLots.value.length
    ? Math.floor(currentDuration.value / passedLots.value.length)
    : 0
  );

  const updateCurrentDuration = () => {
    const timerStart = auction.value.live_auction_start ? moment(auction.value.live_auction_start) : null;
    const timerEnd = auctionStatus.value === AuctionStatuses.ENDED && auction.value.live_auction_end
        ? moment(auction.value.live_auction_end)
        : moment();

    if (!timerStart) {
      currentDuration.value = 0;
      return;
    }

    const diffInSeconds = timerEnd.diff(timerStart, 'seconds');
    currentDuration.value = diffInSeconds > 0 ? diffInSeconds : 0;
  };

  const stopDurationInterval = () => {
    if (durationInterval) {
      clearInterval(durationInterval);
      durationInterval = null;
    }
  };

  const startDurationInterval = () => {
    stopDurationInterval();
    updateCurrentDuration();

    if (auctionStatus.value !== AuctionStatuses.ENDED && auction.value.live_auction_start) {
      durationInterval = window.setInterval(() => {
        updateCurrentDuration();
      }, 1000);
    }
  };

  onMounted(() => {
    startDurationInterval();
  });

  onBeforeUnmount(() => {
    stopDurationInterval();
  });

  watch(
    () => [auction.value.live_auction_start, auction.value.live_auction_end, auctionStatus.value],
    () => {
      startDurationInterval();
    }
  );

  watch(() => passedLots.value.length, () => {
    updateCurrentDuration();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(trans)("live.tabs.statistic.current_duration")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Timer, {
          "data-days": timerDays.value,
          "data-hours": timerHours.value,
          "data-minutes": timerMinutes.value,
          "data-seconds": timerSeconds.value,
          "is-paused": timerIsPaused.value
        }, null, 8, ["data-days", "data-hours", "data-minutes", "data-seconds", "is-paused"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(trans)("live.tabs.statistic.time_per_lot")), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(timePerLot.value) + " " + _toDisplayString(_unref(trans)("live.tabs.statistic.sec")), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(trans)("live.tabs.statistic.lots_in_auction")), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(lots.value.length), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(trans)("live.tabs.statistic.sold_unsold")), 1),
      _createElementVNode("div", _hoisted_13, _toDisplayString(soldLots.value.length) + " / " + _toDisplayString(unsoldLots.value.length), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(trans)("live.tabs.statistic.total_sales")), 1),
      _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(format_currency)(totalSales.value)), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(trans)("live.tabs.statistic.highest_price")), 1),
      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(format_currency)(highestPrice.value)), 1)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(trans)("live.tabs.statistic.bidders_participated")), 1),
      _createElementVNode("div", _hoisted_22, _toDisplayString(biddersCount.value), 1)
    ])
  ]))
}
}

})